import { SidebarService } from './../../service/sidebar.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NavbarService } from '../../service/navbar.service';
import { debug } from 'util';
import { SessionService } from '../../service/session.service';
import { Constants } from '../../constant';
import { CandidateService } from '../../service/candidate.service';
import { DialogService } from '../../service/dialog.service';
import { Router } from '@angular/router';
import { AccessibilityService } from '../../service/accessibility.service';
import { Title } from "@angular/platform-browser";
import { AuthService } from '../../service/auth.service';


@Component({
  selector: 'app-ballotreview',
  templateUrl: './ballotreview.component.html',
  styleUrls: ['./ballotreview.component.scss']
})

export class BallotreviewComponent implements OnInit, AfterViewInit {
  readonly CONSTANTS = Constants;
  reviewCandidates: any;
  error: string;
  @Output() notifyViewChange = new EventEmitter();
  blackout: boolean;
  @ViewChild('submitMsg') submitMsg: any;
  submitMsgWarning: boolean;
  @ViewChild('landtitle') landtitle: ElementRef;
  constructor(public sessionService: SessionService,
    private candidateService: CandidateService,
    private dialogService: DialogService,
    private accessibilityService: AccessibilityService,
    private authService: AuthService,
    private router: Router,
    private titleService: Title) {
    this.titleService.setTitle('Review and Submit - 2026 CAPE Contract Ratification');
  }

  ngOnInit() {
    this.sessionService.getSessionValue(this.CONSTANTS.CANDIDATE_KEY).subscribe((response: any) => {
      this.reviewCandidates = JSON.parse(response['value']);

    });
    this.blackout = this.accessibilityService.current.blackout;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.submitMsg &&  this.submitMsg.nativeElement.innerHTML) {
        this.submitMsgWarning = true;
      }
      else { this.submitMsgWarning = false }
    }, 1000);
    this.setFocus();
    setTimeout(() => this.addToButton(), 1000);
  }

  addToButton() {
    let selection = document.getElementsByClassName('candidatename');
    let buttonText = document.getElementsByClassName('change-selection');

    for (var i = 0; i < selection.length; i++) {
      if (selection[i].innerHTML != 'No choice has been selected.') {
        buttonText[i].innerHTML += '<span class="sr-only">' + selection[i].innerHTML + ' currently selected.</span>';
      }
      else {
        buttonText[i].innerHTML += '<span class="sr-only">' + selection[i].innerHTML + '</span>';
      }
      
    }
  }

  submitVote() {

    var model = {
      VotesToRecord: [] = [],
      Source: 'online'
    };

    // collect the Vote(s) to be recorded -- This should REALLY be in its own function (IMHO)
    this.reviewCandidates.map((candidateDetail, candidateDetailIndex) => {
      candidateDetail.Candidates.map((candidate, candidatesIndex) => {
        if (candidate.IsChecked) {
          model.VotesToRecord.push({
            CandidateID: candidate.CandidateId
          });
        }
      });
    });

    let returnedDlgPromise: any;

    if (model.VotesToRecord.length > 0) {
      // normal message
      returnedDlgPromise = this.dialogService.confirm('Confirm Submission',
        'By selecting Yes, your vote will be submitted. Are you sure you want to continue?');
    } else if (model.VotesToRecord.length === 0) {
      // NO VOTE(S) message
      returnedDlgPromise = this.dialogService.confirm('Confirm Submission',
        'You have not made a selection for this election. Are you sure you want to continue?');
    }

    if (returnedDlgPromise !== null && returnedDlgPromise !== undefined) {
      returnedDlgPromise.then(
        (confirmed) => {
          if (confirmed) {
            this.titleService.setTitle('Online Ballot Submitted Page');
            if (model && model.VotesToRecord.length >= 0) {
              this.candidateService.voteRecord(model).subscribe((response: any) => {
                if (response.status === 200) {
                  if (response.result.VotingSuccessful === 0) {
                    // Votes were successfully recorded
                    this.sessionService.abandonSessionState();
                    this.router.navigate(['/success']);
                  }

                  if (response.result.VotingSuccessful === -2 || response.result.VotingSuccessful === -5) {
                    this.authService._alreadyVoted = true;
                    this.authService.logout();
                    this.router.navigate(['/#']);
                  }
                }
              },
                error => {
                  // TODO: Should the be DISPLAYED in some way or another?
                  this.error = error;
                }
              );
            }
          }
        })
        .catch(() => console.log(
          'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
  }

  changeSelection(idx) {
    this.notifyViewChange.emit(idx);
    this.router.navigate(['/voting'],
      { queryParams: { 'pageIndex': idx }, skipLocationChange: true });
  }

  gotoSettings() {
    this.router.navigate(['/settings']);
  }
  setFocus() {
    this.landtitle.nativeElement.focus();
  }

}



// WEBPACK FOOTER //
// ./src/app/features/ballotreview/ballotreview.component.ts